// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import api from "../api/axiosInstance";
// import { formatDateTime } from "../utils/formatters";
// import Pagination from "../components/Pagination";

// // Team Overview rows per page.
// const TEAM_PAGE_SIZE = 10;

// export default function AdminPanel() {
//   const [users, setUsers] = useState([]);
//   const [overviewCounts, setOverviewCounts] = useState({ candidateCounts: {}, clientCounts: {} });
//   const [error, setError] = useState("");

//   // Resume-generation stats — separate loading state from the rest of the
//   // page since this section refetches on its own (date range change)
//   // without disturbing the Team Overview table above it.
//   const [stats, setStats] = useState(null);
//   const [statsRange, setStatsRange] = useState({ startDate: "", endDate: "" });
//   const [statsLoading, setStatsLoading] = useState(false);

//   // Team Overview page number. The full user list is already loaded (it's
//   // small), so paging happens here in the browser — no extra API calls.
//   const [teamPage, setTeamPage] = useState(1);

//   useEffect(() => {
//     const fetchUsers = async () => {
//       try {
//         const res = await api.get("/admin/users");
//         setUsers(res.data.users);
//       } catch (err) {
//         setError(err.response?.data?.message || "Failed to load users.");
//       }
//     };
//     const fetchOverviewCounts = async () => {
//       try {
//         const res = await api.get("/admin/team-overview-counts");
//         setOverviewCounts({ candidateCounts: res.data.candidateCounts, clientCounts: res.data.clientCounts });
//       } catch (err) {
//         setError(err.response?.data?.message || "Failed to load team overview counts.");
//       }
//     };
//     fetchUsers();
//     fetchOverviewCounts();
//   }, []);

//   const fetchStats = async (range) => {
//     setStatsLoading(true);
//     try {
//       const params = {};
//       if (range.startDate) params.startDate = range.startDate;
//       if (range.endDate) params.endDate = range.endDate;
//       const res = await api.get("/admin/resume-stats", { params });
//       setStats(res.data);
//     } catch (err) {
//       setError(err.response?.data?.message || "Failed to load resume generation stats.");
//     } finally {
//       setStatsLoading(false);
//     }
//   };

//   // Last 30 days on first load, same default the backend falls back to
//   // when no dates are given — kept in sync here just so the date inputs
//   // don't sit blank while a real range is already active.
//   useEffect(() => {
//     fetchStats({ startDate: "", endDate: "" });
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const recruiterRows = stats?.range?.filter((r) => r.role === "RECRUITER") || [];
//   const teamLeadRows = stats?.range?.filter((r) => r.role === "TEAM_LEAD") || [];

//   // Per-recruiter breakdown — this is the admin-specific value this page
//   // adds over just visiting Candidates/Clients directly: an at-a-glance
//   // view of who's added what, without a separate query per user.
//   const teamOverview = users
//     .filter((u) => u.role !== "ADMIN")
//     .map((u) => ({
//       ...u,
//       candidateCount: overviewCounts.candidateCounts[u._id] || 0,
//       clientCount: overviewCounts.clientCounts[u._id] || 0,
//     }));

//   // Same shape the backend's pagination helper returns, so the shared
//   // Pagination component works unchanged.
//   const teamTotalPages = Math.ceil(teamOverview.length / TEAM_PAGE_SIZE);
//   const currentTeamPage = Math.min(teamPage, Math.max(teamTotalPages, 1)); // stays valid if the list shrinks
//   const teamPagination = {
//     page: currentTeamPage,
//     limit: TEAM_PAGE_SIZE,
//     total: teamOverview.length,
//     totalPages: teamTotalPages,
//   };
//   const teamPageRows = teamOverview.slice(
//     (currentTeamPage - 1) * TEAM_PAGE_SIZE,
//     currentTeamPage * TEAM_PAGE_SIZE
//   );

//   return (
//     <div className="page-container page-container-wide">
//       <div className="page-header">
//         <h2>Admin Panel</h2>
//       </div>

//       {error && <div className="auth-error">{error}</div>}

//       <div className="stats-card">
//         <div className="filter-row" style={{ marginBottom: "16px" }}>
//           <div className="filter-field">
//             <label>From</label>
//             <input
//               type="date"
//               value={statsRange.startDate}
//               onChange={(e) => setStatsRange((r) => ({ ...r, startDate: e.target.value }))}
//             />
//           </div>
//           <div className="filter-field">
//             <label>To</label>
//             <input
//               type="date"
//               value={statsRange.endDate}
//               onChange={(e) => setStatsRange((r) => ({ ...r, endDate: e.target.value }))}
//             />
//           </div>
//           <div className="filter-actions">
//             <button type="button" onClick={() => fetchStats(statsRange)} disabled={statsLoading}>
//               {statsLoading ? "Loading..." : "Apply range"}
//             </button>
//           </div>
//         </div>

//         <div className="metric-grid">
//           <div className="metric-card">
//             <div className="metric-label">Resumes generated today</div>
//             <div className="metric-value">{stats ? stats.todayTotal : "-"}</div>
//           </div>
//           <div className="metric-card">
//             <div className="metric-label">Resumes generated in range</div>
//             <div className="metric-value">{stats ? stats.rangeTotal : "-"}</div>
//           </div>
//         </div>

//         <div className="two-col-layout" style={{ marginTop: "16px" }}>
//           <div className="two-col-content">
//             <h4 style={{ marginTop: 0 }}>By recruiter</h4>
//             {recruiterRows.length === 0 ? (
//               <p className="form-section-hint">No resumes generated by a recruiter in this range.</p>
//             ) : (
//               <table className="simple-table">
//                 <thead>
//                   <tr>
//                     <th>Recruiter</th>
//                     <th>Resumes generated</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {recruiterRows.map((r) => (
//                     <tr key={r.userId}>
//                       <td>{r.name}</td>
//                       <td>{r.count}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             )}
//           </div>
//           <div className="two-col-content">
//             <h4 style={{ marginTop: 0 }}>By team lead</h4>
//             {teamLeadRows.length === 0 ? (
//               <p className="form-section-hint">No resumes generated by a team lead in this range.</p>
//             ) : (
//               <table className="simple-table">
//                 <thead>
//                   <tr>
//                     <th>Team lead</th>
//                     <th>Resumes generated</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {teamLeadRows.map((r) => (
//                     <tr key={r.userId}>
//                       <td>{r.name}</td>
//                       <td>{r.count}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             )}
//           </div>
//         </div>
//       </div>

//       <div className="page-header" style={{ marginTop: "8px" }}>
//         <h3>Team Overview</h3>
//         <div>
//           <Link to="/dashboard">
//             <button type="button">View All Candidates</button>
//           </Link>{" "}
//           <Link to="/dashboard/clients">
//             <button type="button">View All Clients</button>
//           </Link>
//         </div>
//       </div>

//       {teamOverview.length === 0 ? (
//         <p>No team leads or recruiters registered yet.</p>
//       ) : (
//         <>
//         <table className="simple-table">
//           <thead>
//             <tr>
//               <th>Name</th>
//               <th>Email</th>
//               <th>Role</th>
//               <th>Status</th>
//               <th>Candidates Added</th>
//               <th>Clients Added</th>
//               <th>Added On</th>
//             </tr>
//           </thead>
//           <tbody>
//             {teamPageRows.map((u) => (
//               <tr key={u._id}>
//                 <td>{u.name}</td>
//                 <td>{u.email}</td>
//                 <td>{u.role}</td>
//                 <td>{u.status}</td>
//                 <td>{u.candidateCount}</td>
//                 <td>{u.clientCount}</td>
//                 <td>{formatDateTime(u.createdAt)}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//         <Pagination pagination={teamPagination} onPageChange={setTeamPage} />
//         </>
//       )}
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api/axiosInstance";
import { formatDateTime } from "../utils/formatters";
import Pagination from "../components/Pagination";

// Team Overview rows per page.
const TEAM_PAGE_SIZE = 10;
// "By recruiter" resume-generation rows per page.
const RECRUITER_PAGE_SIZE = 10;

export default function AdminPanel() {
  const [users, setUsers] = useState([]);
  const [overviewCounts, setOverviewCounts] = useState({ candidateCounts: {}, clientCounts: {} });
  const [error, setError] = useState("");

  // Resume-generation stats — separate loading state from the rest of the
  // page since this section refetches on its own (date range change)
  // without disturbing the Team Overview table above it.
  const [stats, setStats] = useState(null);
  const [statsRange, setStatsRange] = useState({ startDate: "", endDate: "" });
  const [statsLoading, setStatsLoading] = useState(false);

  // Team Overview page number. The full user list is already loaded (it's
  // small), so paging happens here in the browser — no extra API calls.
  const [teamPage, setTeamPage] = useState(1);

  // "By recruiter" page number. Same idea: the stats response already has
  // every recruiter row for the range, so paging is done in the browser.
  const [recruiterPage, setRecruiterPage] = useState(1);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await api.get("/admin/users");
        setUsers(res.data.users);
      } catch (err) {
        setError(err.response?.data?.message || "Failed to load users.");
      }
    };
    const fetchOverviewCounts = async () => {
      try {
        const res = await api.get("/admin/team-overview-counts");
        setOverviewCounts({ candidateCounts: res.data.candidateCounts, clientCounts: res.data.clientCounts });
      } catch (err) {
        setError(err.response?.data?.message || "Failed to load team overview counts.");
      }
    };
    fetchUsers();
    fetchOverviewCounts();
  }, []);

  const fetchStats = async (range) => {
    setStatsLoading(true);
    try {
      const params = {};
      if (range.startDate) params.startDate = range.startDate;
      if (range.endDate) params.endDate = range.endDate;
      const res = await api.get("/admin/resume-stats", { params });
      setStats(res.data);
      // New date range = new list of recruiters, so start again at page 1.
      setRecruiterPage(1);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to load resume generation stats.");
    } finally {
      setStatsLoading(false);
    }
  };

  // Last 30 days on first load, same default the backend falls back to
  // when no dates are given — kept in sync here just so the date inputs
  // don't sit blank while a real range is already active.
  useEffect(() => {
    fetchStats({ startDate: "", endDate: "" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const recruiterRows = stats?.range?.filter((r) => r.role === "RECRUITER") || [];
  const teamLeadRows = stats?.range?.filter((r) => r.role === "TEAM_LEAD") || [];

  // "By recruiter" pagination — same { page, limit, total, totalPages }
  // shape the shared Pagination component expects.
  const recruiterTotalPages = Math.ceil(recruiterRows.length / RECRUITER_PAGE_SIZE);
  const currentRecruiterPage = Math.min(recruiterPage, Math.max(recruiterTotalPages, 1)); // stays valid if the list shrinks
  const recruiterPagination = {
    page: currentRecruiterPage,
    limit: RECRUITER_PAGE_SIZE,
    total: recruiterRows.length,
    totalPages: recruiterTotalPages,
  };
  const recruiterPageRows = recruiterRows.slice(
    (currentRecruiterPage - 1) * RECRUITER_PAGE_SIZE,
    currentRecruiterPage * RECRUITER_PAGE_SIZE
  );

  // Per-recruiter breakdown — this is the admin-specific value this page
  // adds over just visiting Candidates/Clients directly: an at-a-glance
  // view of who's added what, without a separate query per user.
  const teamOverview = users
    .filter((u) => u.role !== "ADMIN")
    .map((u) => ({
      ...u,
      candidateCount: overviewCounts.candidateCounts[u._id] || 0,
      clientCount: overviewCounts.clientCounts[u._id] || 0,
    }));

  // Same shape the backend's pagination helper returns, so the shared
  // Pagination component works unchanged.
  const teamTotalPages = Math.ceil(teamOverview.length / TEAM_PAGE_SIZE);
  const currentTeamPage = Math.min(teamPage, Math.max(teamTotalPages, 1)); // stays valid if the list shrinks
  const teamPagination = {
    page: currentTeamPage,
    limit: TEAM_PAGE_SIZE,
    total: teamOverview.length,
    totalPages: teamTotalPages,
  };
  const teamPageRows = teamOverview.slice(
    (currentTeamPage - 1) * TEAM_PAGE_SIZE,
    currentTeamPage * TEAM_PAGE_SIZE
  );

  return (
    <div className="page-container page-container-wide">
      <div className="page-header">
        <h2>Admin Panel</h2>
      </div>

      {error && <div className="auth-error">{error}</div>}

      <div className="stats-card">
        <div className="filter-row" style={{ marginBottom: "16px" }}>
          <div className="filter-field">
            <label>From</label>
            <input
              type="date"
              value={statsRange.startDate}
              onChange={(e) => setStatsRange((r) => ({ ...r, startDate: e.target.value }))}
            />
          </div>
          <div className="filter-field">
            <label>To</label>
            <input
              type="date"
              value={statsRange.endDate}
              onChange={(e) => setStatsRange((r) => ({ ...r, endDate: e.target.value }))}
            />
          </div>
          <div className="filter-actions">
            <button type="button" onClick={() => fetchStats(statsRange)} disabled={statsLoading}>
              {statsLoading ? "Loading..." : "Apply range"}
            </button>
          </div>
        </div>

        <div className="metric-grid">
          <div className="metric-card">
            <div className="metric-label">Resumes generated today</div>
            <div className="metric-value">{stats ? stats.todayTotal : "-"}</div>
          </div>
          <div className="metric-card">
            <div className="metric-label">Resumes generated in range</div>
            <div className="metric-value">{stats ? stats.rangeTotal : "-"}</div>
          </div>
        </div>

        <div className="two-col-layout" style={{ marginTop: "16px" }}>
          <div className="two-col-content">
            <h4 style={{ marginTop: 0 }}>By recruiter</h4>
            {recruiterRows.length === 0 ? (
              <p className="form-section-hint">No resumes generated by a recruiter in this range.</p>
            ) : (
              <>
                <table className="simple-table">
                  <thead>
                    <tr>
                      <th>Recruiter</th>
                      <th>Resumes generated</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recruiterPageRows.map((r) => (
                      <tr key={r.userId}>
                        <td>{r.name}</td>
                        <td>{r.count}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <Pagination pagination={recruiterPagination} onPageChange={setRecruiterPage} />
              </>
            )}
          </div>
          <div className="two-col-content">
            <h4 style={{ marginTop: 0 }}>By team lead</h4>
            {teamLeadRows.length === 0 ? (
              <p className="form-section-hint">No resumes generated by a team lead in this range.</p>
            ) : (
              <table className="simple-table">
                <thead>
                  <tr>
                    <th>Team lead</th>
                    <th>Resumes generated</th>
                  </tr>
                </thead>
                <tbody>
                  {teamLeadRows.map((r) => (
                    <tr key={r.userId}>
                      <td>{r.name}</td>
                      <td>{r.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>

      <div className="page-header" style={{ marginTop: "8px" }}>
        <h3>Team Overview</h3>
        <div>
          <Link to="/dashboard">
            <button type="button">View All Candidates</button>
          </Link>{" "}
          <Link to="/dashboard/clients">
            <button type="button">View All Clients</button>
          </Link>
        </div>
      </div>

      {teamOverview.length === 0 ? (
        <p>No team leads or recruiters registered yet.</p>
      ) : (
        <>
        <table className="simple-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Status</th>
              <th>Candidates Added</th>
              <th>Clients Added</th>
              <th>Added On</th>
            </tr>
          </thead>
          <tbody>
            {teamPageRows.map((u) => (
              <tr key={u._id}>
                <td>{u.name}</td>
                <td>{u.email}</td>
                <td>{u.role}</td>
                <td>{u.status}</td>
                <td>{u.candidateCount}</td>
                <td>{u.clientCount}</td>
                <td>{formatDateTime(u.createdAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination pagination={teamPagination} onPageChange={setTeamPage} />
        </>
      )}
    </div>
  );
}